import { render, staticRenderFns } from "./FormFieldsVehicles.vue?vue&type=template&id=b4d7b4e4&scoped=true&"
import script from "./FormFieldsVehicles.vue?vue&type=script&lang=js&"
export * from "./FormFieldsVehicles.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsVehicles.vue?vue&type=style&index=0&id=b4d7b4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7b4e4",
  null
  
)

export default component.exports